import React, { forwardRef } from 'react';

import {
  Field,
  FormCheckbox,
  FormInput,
  FormMultiselect,
  FormRadio,
  FormRadioPanel,
  FormRichText,
  FormSelect,
  FormTextarea,
} from './formFields';

function Fields({ title, subtitle, children }: { title?: string; subtitle?: string; children: React.ReactNode }) {
  const classNames = ['space-y-4'];

  if (title || subtitle) {
    classNames.push('mt-4');
  }

  return (
    <fieldset className="min-w-0">
      {title && <legend className="text-base font-medium text-gray-900">{title}</legend>}
      {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
      <div className={classNames.join(' ')}>{children}</div>
    </fieldset>
  );
}

type Props = React.FormHTMLAttributes<HTMLFormElement> & {
  children: React.ReactNode;
};

const Form = forwardRef<HTMLFormElement, Props>(({ id, onSubmit, children, ...rest }, ref) => {
  const classNames = ['relative'];

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (onSubmit) onSubmit(e);
  };

  return (
    <form ref={ref} id={id} className={classNames.join(' ')} onSubmit={handleSubmit} {...rest}>
      {children}
    </form>
  );
});

export default Object.assign(Form, {
  Field,
  Fields,
  Input: FormInput,
  Checkbox: FormCheckbox,
  Radio: FormRadio,
  RadioPanel: FormRadioPanel,
  Textarea: FormTextarea,
  RichText: FormRichText,
  Select: FormSelect,
  Multiselect: FormMultiselect,
});
